import { render, staticRenderFns } from "./livechatTab.vue?vue&type=template&id=cdf67192&lang=pug"
import script from "./livechatTab.vue?vue&type=script&lang=js"
export * from "./livechatTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports